/**
 * Build year dropdown options from make year ranges.
 * Coerces start/end years with Number.parseInt so mixed string/int API values compare correctly.
 *
 * @param {Array<{start_year: string|number, end_year: string|number}>} year_makes
 * @return {Array<{ui: number, url: number}>}
 */
function buildActiveYearOptions(year_makes) {
	const year_options = [];
	let min_year = null;
	let max_year = null;

	for (let i = 0, j = year_makes.length; i < j; i++) {
		const year_make = year_makes[i];
		const start_year = Number.parseInt(year_make.start_year, 10);
		const end_year = Number.parseInt(year_make.end_year, 10);

		if (Number.isNaN(start_year) || Number.isNaN(end_year) || start_year > end_year) {
			continue;
		}

		if (min_year === null || start_year < min_year) {
			min_year = start_year;
		}
		if (max_year === null || end_year > max_year) {
			max_year = end_year;
		}
	}

	if (min_year === null || max_year === null) {
		return [];
	}

	for (let year = max_year; year >= min_year; year--) {
		year_options.push({ ui: year, url: year });
	}

	return year_options;
}

module.exports = {
	buildActiveYearOptions,
};
